const padStart = (number: number) => {
  return number.toString().padStart(2, '0');
};

export const dateToCalendarStateIndex = (date: Date) => {
  return `${date.getUTCFullYear()}-${padStart(date.getUTCMonth() + 1)}-${padStart(date.getUTCDate())}`;
};
